import styled from 'styled-components';

import { spaceMixin } from '@zillow/constellation';

export const StyledBar = styled.div<{ left: number; right: number; borderColor: string }>`
  top: ${spaceMixin('sm')};
  left: ${(props) => `${props.left}%`};
  right: ${(props) => `${props.right}%`};
  position: absolute;
  border-width: 4px;
  border-style: solid;
  border-color: ${(props) => props.borderColor};
  border-radius: 10px;
`;
